var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "page-header"
  }, [_c('b-breadcrumb', {
    staticClass: "m-0"
  }, [_c('b-breadcrumb-item', {
    attrs: {
      "to": {
        name: 'DashboardHome'
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("獎勵應用中心")]), _c('b-breadcrumb-item', {
    attrs: {
      "active": ""
    }
  }, [_vm._v("訂單點數設定")])], 1)], 1)])]), _c('b-card', [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v("訂單點數設定")]), _c('b-overlay', {
    attrs: {
      "show": _vm.isLoading || _vm.isSubmmiting,
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "訂單來源通路",
      "label-for": "merchant"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [!_vm.isLoading && !_vm.isEdit && _vm.module.merchant_id !== null ? _c('b-form-checkbox', {
    staticClass: "text-nowrap mr-3",
    model: {
      value: _vm.isFormEnabled,
      callback: function callback($$v) {
        _vm.isFormEnabled = $$v;
      },
      expression: "isFormEnabled"
    }
  }, [_vm._v("設定")]) : _vm._e(), _c('b-form-select', {
    attrs: {
      "options": _vm.merchants,
      "disabled": _vm.isFetchingMerchants,
      "size": "sm"
    },
    on: {
      "input": _vm.fetchModule
    },
    model: {
      value: _vm.module.merchant_id,
      callback: function callback($$v) {
        _vm.$set(_vm.module, "merchant_id", $$v);
      },
      expression: "module.merchant_id"
    }
  })], 1)]), _c('b-overlay', {
    staticClass: "spinner-transparent",
    attrs: {
      "show": !_vm.isFormEnabled,
      "opacity": "0.6",
      "blur": "1px"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "是否啟用",
      "label-for": "isModuleEnabled"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.module.is_enabled,
      callback: function callback($$v) {
        _vm.$set(_vm.module, "is_enabled", $$v);
      },
      expression: "module.is_enabled"
    }
  })], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "入點會員通路",
      "label-for": "merchantTypes"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('b-form-select', {
    attrs: {
      "options": _vm.merchantTypes,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.to_merchant_type,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config, "to_merchant_type", $$v);
      },
      expression: "module.module_config.to_merchant_type"
    }
  })], 1)]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "訂單金額欄位"
    }
  }, [_c('b-form-select', {
    staticStyle: {
      "width": "150px"
    },
    attrs: {
      "options": _vm.priceColumnOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.price_column,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config, "price_column", $$v);
      },
      expression: "module.module_config.price_column"
    }
  })], 1), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v(" 訂單入點 "), _c('i', {
    staticClass: "fa fa-question-circle ml-2 text-muted",
    staticStyle: {
      "font-size": "1rem"
    },
    attrs: {
      "id": "order-point-tooltip"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "order-point-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 因訂單成立，系統發放點數予用戶 ")])], 1), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單條件")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', [_c('h6', {
    staticClass: "font-weight-bold"
  }, [_vm._v(" 時間範圍 ")])]), _c('b-form-group', {
    ref: "startTimeFormGroup",
    staticClass: "ml-4",
    attrs: {
      "id": "start-time-form-group"
    }
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "start_time_query"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "start_time_query") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "start_time_query",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("起始時間：")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "140px"
    },
    attrs: {
      "options": _vm.startTimeQueryConditionOptions,
      "disabled": !_vm.conditionsCheckboxType.includes('start_time_query'),
      "size": "sm"
    },
    model: {
      value: _vm.startTimeCondition.type,
      callback: function callback($$v) {
        _vm.$set(_vm.startTimeCondition, "type", $$v);
      },
      expression: "startTimeCondition.type"
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.startTimeCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('start_time_query'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'startTimeCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")]), _c('i', {
    staticClass: "fa fa-question-circle ml-2 text-muted",
    attrs: {
      "id": "start-time-condition-tooltip"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "start-time-condition-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 特定天數後，處理入點。 ")])], 1), _c('b-form-invalid-feedback', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "state": !_vm.isTimeRangeInvalid,
      "force-show": _vm.isTimeRangeInvalid
    }
  }, [_vm._v(" 起始時間必須小於截止時間 ")])], 1), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "end_time_query"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "end_time_query") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "end_time_query",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("截止時間：")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "140px"
    },
    attrs: {
      "options": _vm.endTimeQueryConditionOptions,
      "disabled": !_vm.conditionsCheckboxType.includes('end_time_query') || _vm.conditionsCheckboxType.includes('start_time_query') && _vm.conditionsCheckboxType.includes('end_time_query'),
      "size": "sm"
    },
    model: {
      value: _vm.endTimeCondition.type,
      callback: function callback($$v) {
        _vm.$set(_vm.endTimeCondition, "type", $$v);
      },
      expression: "endTimeCondition.type"
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.endTimeCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('end_time_query'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'endTimeCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")]), _c('i', {
    staticClass: "fa fa-question-circle ml-2 text-muted",
    attrs: {
      "id": "end-time-condition-tooltip"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "end-time-condition-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 超過特定天數尚未入點之訂單，將視為失效，不予處理。 ")])], 1)]), _c('b-form-group', {
    staticClass: "ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "gaining_calculation_start_date"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "gaining_calculation_start_date") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "gaining_calculation_start_date",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "options": _vm.calculationStartDateByOptions,
      "disabled": !_vm.conditionsCheckboxType.includes('gaining_calculation_start_date'),
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.gaining.by,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.gaining, "by", $$v);
      },
      expression: "module.module_config.calculation_start_date.gaining.by"
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("應晚於：")]), _c('div', {
    staticClass: "m-1 d-flex"
  }, [_c('AppDatePicker', {
    attrs: {
      "size": "sm",
      "disabled": !_vm.conditionsCheckboxType.includes('gaining_calculation_start_date')
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.gaining.date,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.gaining, "date", $$v);
      },
      expression: "module.module_config.calculation_start_date.gaining.date"
    }
  })], 1)])]), _c('hr', {
    staticClass: "my-4"
  }), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("進階篩選")]), _c('small', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("設定特定訂單狀態或分店")])]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_order_status",
      "value": "order_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "order_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "order_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("訂單狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.orderStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('order_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'orderStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('order_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.orderStatusIncludeJson,
      callback: function callback($$v) {
        _vm.orderStatusIncludeJson = $$v;
      },
      expression: "orderStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.orderStatusExcludeJson,
      callback: function callback($$v) {
        _vm.orderStatusExcludeJson = $$v;
      },
      expression: "orderStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_delivery_status",
      "value": "delivery_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "delivery_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "delivery_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("物流狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.deliveryStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('delivery_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'deliveryStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('delivery_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.deliveryStatusIncludeJson,
      callback: function callback($$v) {
        _vm.deliveryStatusIncludeJson = $$v;
      },
      expression: "deliveryStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.deliveryStatusExcludeJson,
      callback: function callback($$v) {
        _vm.deliveryStatusExcludeJson = $$v;
      },
      expression: "deliveryStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_return_status",
      "value": "return_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "return_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "return_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("退貨狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.returnStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('return_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'returnStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('return_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.returnStatusIncludeJson,
      callback: function callback($$v) {
        _vm.returnStatusIncludeJson = $$v;
      },
      expression: "returnStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.returnStatusExcludeJson,
      callback: function callback($$v) {
        _vm.returnStatusExcludeJson = $$v;
      },
      expression: "returnStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_payment_status",
      "value": "payment_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "payment_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "payment_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("付款狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.paymentStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('payment_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'paymentStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('payment_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.paymentStatusIncludeJson,
      callback: function callback($$v) {
        _vm.paymentStatusIncludeJson = $$v;
      },
      expression: "paymentStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.paymentStatusExcludeJson,
      callback: function callback($$v) {
        _vm.paymentStatusExcludeJson = $$v;
      },
      expression: "paymentStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-0 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_branch_list",
      "value": "branch_list_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "branch_list_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "branch_list_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("允許/排除 分店名單")])]), _vm.conditionsCheckboxType.includes('branch_list_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許分店 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.branchListIncludeJson,
      callback: function callback($$v) {
        _vm.branchListIncludeJson = $$v;
      },
      expression: "branchListIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除分店 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.branchListExcludeJson,
      callback: function callback($$v) {
        _vm.branchListExcludeJson = $$v;
      },
      expression: "branchListExcludeJson"
    }
  })], 1)]) : _vm._e()])], 1)], 1)]), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("點數計算")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "form-check"
  }, [_c('b-form-group', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.module.module_config.strategy,
      expression: "module.module_config.strategy"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "id": "strategy_by_price_only",
      "value": "by_price_only"
    },
    domProps: {
      "checked": _vm._q(_vm.module.module_config.strategy, "by_price_only")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.module.module_config, "strategy", "by_price_only");
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strategy_by_price_only"
    }
  }, [_vm._v("無區分會員等級")])]), _c('div', {
    staticClass: "d-flex align-items-center py-2 mt-3 mb-3"
  }, [_c('b-form-group', {
    staticClass: "mb-0 flex-grow-1 d-inline-flex align-items-center"
  }, [_vm._v(" 訂單滿 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "disabled": _vm.module.module_config.strategy !== 'by_price_only',
      "type": "number",
      "value": _vm.module.module_config.by_price_only_params.convertion_price_threshold,
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'module.module_config.by_price_only_params.convertion_price_threshold', 0);
      }
    }
  }), _vm._v(" 元， 給 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "disabled": _vm.module.module_config.strategy !== 'by_price_only',
      "type": "number",
      "value": _vm.module.module_config.by_price_only_params.points_per_threshold,
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'module.module_config.by_price_only_params.points_per_threshold', 0);
      }
    }
  }), _vm._v(" 點 "), _c('b-form-radio-group', {
    staticClass: "d-inline-flex ml-2",
    attrs: {
      "disabled": _vm.module.module_config.strategy !== 'by_price_only',
      "options": _vm.allowMultipleConvertionOptions
    },
    model: {
      value: _vm.module.module_config.by_price_only_params.allow_multiple_convertion,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.by_price_only_params, "allow_multiple_convertion", $$v);
      },
      expression: "module.module_config.by_price_only_params.allow_multiple_convertion"
    }
  })], 1)], 1), _c('b-form-group', {
    staticClass: "d-flex"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.module.module_config.strategy,
      expression: "module.module_config.strategy"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "id": "strategy_by_customer_level",
      "value": "by_customer_level"
    },
    domProps: {
      "checked": _vm._q(_vm.module.module_config.strategy, "by_customer_level")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.module.module_config, "strategy", "by_customer_level");
      }
    }
  }), _c('label', {
    attrs: {
      "for": "strategy_by_customer_level"
    }
  }, [_vm._v("依會員等級")])]), _vm.module.module_config.by_customer_level_params.levels.length > 0 ? _c('div', {
    staticClass: "mt-3 mb-3 customer-level-grid"
  }, _vm._l(_vm.module.module_config.by_customer_level_params.levels, function (level, index) {
    return _c('div', {
      key: index,
      staticClass: "customer-level-item"
    }, [_c('div', {
      staticClass: "text-right mr-2"
    }, [_vm._v(" " + _vm._s(_vm.levelNameMap[level.customer_level_code]) + " ")]), _vm._v(" 訂單滿 "), _c('b-form-input', {
      staticClass: "w-auto",
      attrs: {
        "disabled": _vm.module.module_config.strategy !== 'by_customer_level',
        "type": "number",
        "value": level.convertion_price_threshold,
        "min": "0",
        "step": "1",
        "size": "sm"
      },
      on: {
        "keydown": function keydown($event) {
          return _vm.preventInvalidNumberKey($event, 0);
        },
        "input": function input($event) {
          return _vm.onPositiveIntInput($event, "module.module_config.by_customer_level_params.levels[".concat(index, "].convertion_price_threshold"), 0);
        }
      }
    }), _vm._v(" 元， 給 "), _c('b-form-input', {
      staticClass: "w-auto",
      attrs: {
        "disabled": _vm.module.module_config.strategy !== 'by_customer_level',
        "type": "number",
        "value": level.points_per_threshold,
        "min": "0",
        "step": "1",
        "size": "sm"
      },
      on: {
        "keydown": function keydown($event) {
          return _vm.preventInvalidNumberKey($event, 0);
        },
        "input": function input($event) {
          return _vm.onPositiveIntInput($event, "module.module_config.by_customer_level_params.levels[".concat(index, "].points_per_threshold"), 0);
        }
      }
    }), _vm._v(" 點 "), _c('b-form-radio-group', {
      staticClass: "d-inline-flex ml-2",
      attrs: {
        "disabled": _vm.module.module_config.strategy !== 'by_customer_level',
        "options": _vm.allowMultipleConvertionOptions
      },
      model: {
        value: level.allow_multiple_convertion,
        callback: function callback($$v) {
          _vm.$set(level, "allow_multiple_convertion", $$v);
        },
        expression: "level.allow_multiple_convertion"
      }
    })], 1);
  }), 0) : _vm._e()], 1)])]), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("點數過期時間")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm",
      "label": "日期推算基準"
    }
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.expirationStartDateConditionOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.start_date_condition,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "start_date_condition", $$v);
      },
      expression: "module.module_config.expiration.start_date_condition"
    }
  })], 1), _c('div', {
    staticClass: "form-check"
  }, [_c('b-form-group', {
    staticClass: "align-items-center"
  }, [_c('label', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.module.module_config.expiration.type,
      expression: "module.module_config.expiration.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "value": "shifted_date"
    },
    domProps: {
      "checked": _vm._q(_vm.module.module_config.expiration.type, "shifted_date")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.module.module_config.expiration, "type", "shifted_date");
      }
    }
  }), _vm._v(" 依相對時間 ")]), _c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticClass: "w-auto",
    attrs: {
      "type": "number",
      "value": _vm.module.module_config.expiration.number,
      "size": "sm",
      "min": "1",
      "step": "1"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 1);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'module.module_config.expiration.number', 1);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-100",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.expirationUnitOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.unit,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "unit", $$v);
      },
      expression: "module.module_config.expiration.unit"
    }
  })], 1)])])], 1), _c('div', {
    staticClass: "form-check"
  }, [_c('b-form-group', {
    staticClass: "align-items-center"
  }, [_c('label', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.module.module_config.expiration.type,
      expression: "module.module_config.expiration.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "value": "fixed_date"
    },
    domProps: {
      "checked": _vm._q(_vm.module.module_config.expiration.type, "fixed_date")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.module.module_config.expiration, "type", "fixed_date");
      }
    }
  }), _vm._v(" 依特定日期 "), _c('i', {
    staticClass: "fa fa-question-circle ml-1 text-muted",
    staticStyle: {
      "cursor": "pointer"
    },
    attrs: {
      "title": "點擊，觀看設定說明"
    },
    on: {
      "click": function click($event) {
        $event.stopPropagation();
        _vm.showFixedDateModal = true;
      }
    }
  })]), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_vm._v(" 年度起始日： "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.monthOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.period_start_month,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "period_start_month", $$v);
      },
      expression: "module.module_config.expiration.period_start_month"
    }
  }), _vm._v(" 月 "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.dayOptions(_vm.module.module_config.expiration.period_start_month),
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.period_start_day,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "period_start_day", $$v);
      },
      expression: "module.module_config.expiration.period_start_day"
    }
  }), _vm._v(" 日 ")], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_vm._v(" 年度終止日： "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.monthOptions,
      "size": "sm",
      "disabled": ""
    },
    model: {
      value: _vm.module.module_config.expiration.period_end_month,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "period_end_month", $$v);
      },
      expression: "module.module_config.expiration.period_end_month"
    }
  }), _vm._v(" 月 "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.dayOptions(_vm.module.module_config.expiration.period_end_month),
      "size": "sm",
      "disabled": ""
    },
    model: {
      value: _vm.module.module_config.expiration.period_end_day,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "period_end_day", $$v);
      },
      expression: "module.module_config.expiration.period_end_day"
    }
  }), _vm._v(" 日 ")], 1), _c('div', {
    staticClass: "d-flex align-items-center mb-2"
  }, [_vm._v(" 過期日：年度終止日 "), _c('b-form-input', {
    staticClass: "w-auto mx-2",
    attrs: {
      "type": "number",
      "size": "sm",
      "min": "1",
      "step": "1"
    },
    model: {
      value: _vm.module.module_config.expiration.expiry_offset_years,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "expiry_offset_years", _vm._n($$v));
      },
      expression: "module.module_config.expiration.expiry_offset_years"
    }
  }), _vm._v(" 年後的 "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.expiryMonthOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.expiry_month,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "expiry_month", $$v);
      },
      expression: "module.module_config.expiration.expiry_month"
    }
  }), _vm._v(" 月 "), _c('b-form-select', {
    staticClass: "w-auto mx-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.expiryDayOptions,
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.expiration.expiry_day,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.expiration, "expiry_day", $$v);
      },
      expression: "module.module_config.expiration.expiry_day"
    }
  }), _vm._v(" 日 ")], 1), _vm.module.module_config.expiration.type === 'fixed_date' && _vm.fixedDatePreview ? _c('div', {
    staticClass: "mt-2"
  }, [_c('div', {
    staticClass: "d-flex align-items-center",
    staticStyle: {
      "cursor": "pointer",
      "font-size": "0.875rem",
      "color": "#28a745"
    },
    on: {
      "click": function click($event) {
        _vm.showFixedDatePreview = !_vm.showFixedDatePreview;
      }
    }
  }, [_c('i', {
    staticClass: "mr-1",
    class: _vm.showFixedDatePreview ? 'fa fa-chevron-down' : 'fa fa-chevron-right'
  }), _vm._v(" 預覽試算 ")]), _vm.showFixedDatePreview ? _c('div', {
    staticClass: "mt-1 p-2 rounded border border-success",
    staticStyle: {
      "font-size": "0.875rem",
      "color": "#28a745",
      "background-color": "#f0fff4"
    }
  }, [_vm._v(" 若您在 今日: "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.todayStr))]), _vm._v(" 發放點數，"), _c('br'), _vm._v(" 該點數將歸屬於 "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.cycleStartStr) + " ~ " + _vm._s(_vm.fixedDatePreview.cycleEndStr))]), _vm._v(" 週期，並於 "), _c('strong', [_vm._v(_vm._s(_vm.fixedDatePreview.expiryStr))]), _vm._v(" 到期。 ")]) : _vm._e()]) : _vm._e()])], 1), _c('b-modal', {
    attrs: {
      "title": "點數(依特定日期) 說明",
      "ok-only": "",
      "ok-title": "關閉",
      "dialog-class": "modal-half"
    },
    model: {
      value: _vm.showFixedDateModal,
      callback: function callback($$v) {
        _vm.showFixedDateModal = $$v;
      },
      expression: "showFixedDateModal"
    }
  }, [_c('p', [_vm._v("系統將依據您設定的「年度週期」歸納點數，同一週期內獲得的點數，將統一於指定的延長年份日期失效。")]), _c('p', [_c('strong', [_vm._v("舉例情境：")]), _vm._v("若設定週期為 1/10 至 隔年1/9，並於 1 年後的 12/31 失效。若會員在 2026/01/30 獲得點數（屬於2026/01/10 ~ 2027/01/09 週期），該筆點數將於 2028/12/31 正式失效。")])]), _c('div', {
    staticClass: "form-check"
  }, [_c('b-form-group', {
    staticClass: "align-items-center"
  }, [_c('label', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.module.module_config.expiration.type,
      expression: "module.module_config.expiration.type"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "radio",
      "value": "none"
    },
    domProps: {
      "checked": _vm._q(_vm.module.module_config.expiration.type, "none")
    },
    on: {
      "change": function change($event) {
        return _vm.$set(_vm.module.module_config.expiration, "type", "none");
      }
    }
  }), _vm._v(" 無期限 ")])])], 1)], 1)])])]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v(" 訂單扣點 "), _c('i', {
    staticClass: "fa fa-question-circle ml-2 text-muted",
    staticStyle: {
      "font-size": "1rem"
    },
    attrs: {
      "id": "order-deduct-tooltip"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "order-deduct-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 因訂單成立，用戶使用點數折抵 ")])], 1), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單條件")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-flex align-items-center mr-3"
        }, [_vm._v(" 下單後扣除已使用點數 "), _c('i', {
          staticClass: "fa fa-question-circle ml-2",
          attrs: {
            "id": "deduct-point-tooltip"
          }
        })])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.module.module_config.allow_deduct_reward_points_used,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config, "allow_deduct_reward_points_used", $$v);
      },
      expression: "module.module_config.allow_deduct_reward_points_used"
    }
  })], 1), _c('b-tooltip', {
    attrs: {
      "target": "deduct-point-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 訂單若有使用點數，將自動從可用點數中扣除 ")])], 1)], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("時間範圍")])]), _c('b-form-group', {
    staticClass: "ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "deducting_calculation_start_date"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "deducting_calculation_start_date") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "deducting_calculation_start_date",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "options": _vm.calculationStartDateByOptions,
      "disabled": !_vm.conditionsCheckboxType.includes('deducting_calculation_start_date'),
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.deducting.by,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.deducting, "by", $$v);
      },
      expression: "module.module_config.calculation_start_date.deducting.by"
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("應晚於：")]), _c('div', {
    staticClass: "m-1 d-flex"
  }, [_c('AppDatePicker', {
    attrs: {
      "size": "sm",
      "disabled": !_vm.conditionsCheckboxType.includes('deducting_calculation_start_date')
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.deducting.date,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.deducting, "date", $$v);
      },
      expression: "module.module_config.calculation_start_date.deducting.date"
    }
  })], 1)])])], 1)])])])]), _c('section', {
    staticClass: "row mb-5"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_c('h4', {
    staticClass: "mb-4 text-primary"
  }, [_vm._v(" 訂單退貨 "), _c('i', {
    staticClass: "fa fa-question-circle ml-2 text-muted",
    staticStyle: {
      "font-size": "1rem"
    },
    attrs: {
      "id": "order-refund-tooltip"
    }
  }), _c('b-tooltip', {
    attrs: {
      "target": "order-refund-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 因訂單取消或退貨，系統回收已發放之點數 ")])], 1), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("訂單條件")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "mb-4"
  }, [_c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label-cols": "auto",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-flex align-items-center mr-3"
        }, [_vm._v("退單扣點之適用金額"), _c('i', {
          staticClass: "fa fa-question-circle ml-2",
          attrs: {
            "id": "allow-revoke-positive-amount-orders-tooltip"
          }
        })])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "options": _vm.allowRevokePositiveAmountOrdersOptions,
      "size": "sm"
    },
    model: {
      value: _vm.allowRevokePositiveAmountOrders,
      callback: function callback($$v) {
        _vm.allowRevokePositiveAmountOrders = $$v;
      },
      expression: "allowRevokePositiveAmountOrders"
    }
  })], 1), _c('b-tooltip', {
    attrs: {
      "target": "allow-revoke-positive-amount-orders-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 設定退貨扣點機制適用的訂單金額類型 ")])], 1)], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("時間範圍")])]), _c('b-form-group', {
    staticClass: "ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "value": "returning_calculation_start_date"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "returning_calculation_start_date") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "returning_calculation_start_date",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-select', {
    staticClass: "w-auto",
    staticStyle: {
      "min-width": "120px"
    },
    attrs: {
      "options": _vm.calculationStartDateByOptions,
      "disabled": !_vm.conditionsCheckboxType.includes('returning_calculation_start_date'),
      "size": "sm"
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.returning.by,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.returning, "by", $$v);
      },
      expression: "module.module_config.calculation_start_date.returning.by"
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("應晚於：")]), _c('div', {
    staticClass: "m-1 d-flex"
  }, [_c('AppDatePicker', {
    attrs: {
      "size": "sm",
      "disabled": !_vm.conditionsCheckboxType.includes('returning_calculation_start_date')
    },
    model: {
      value: _vm.module.module_config.calculation_start_date.returning.date,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config.calculation_start_date.returning, "date", $$v);
      },
      expression: "module.module_config.calculation_start_date.returning.date"
    }
  })], 1)])])], 1), _c('hr', {
    staticClass: "my-4"
  }), _c('div', [_c('div', {
    staticClass: "d-flex align-items-center mb-3"
  }, [_c('h6', {
    staticClass: "font-weight-bold mb-0"
  }, [_vm._v("進階篩選")]), _c('small', {
    staticClass: "text-muted ml-2"
  }, [_vm._v("設定特定訂單狀態或分店")])]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_revoke_status",
      "value": "revoke_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "revoke_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "revoke_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("訂單狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.revokeStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('revoke_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'revokeStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('revoke_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeStatusIncludeJson,
      callback: function callback($$v) {
        _vm.revokeStatusIncludeJson = $$v;
      },
      expression: "revokeStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeStatusExcludeJson,
      callback: function callback($$v) {
        _vm.revokeStatusExcludeJson = $$v;
      },
      expression: "revokeStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_revoke_delivery_status",
      "value": "revoke_delivery_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "revoke_delivery_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "revoke_delivery_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("物流狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.revokeDeliveryStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('revoke_delivery_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'revokeDeliveryStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('revoke_delivery_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeDeliveryStatusIncludeJson,
      callback: function callback($$v) {
        _vm.revokeDeliveryStatusIncludeJson = $$v;
      },
      expression: "revokeDeliveryStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeDeliveryStatusExcludeJson,
      callback: function callback($$v) {
        _vm.revokeDeliveryStatusExcludeJson = $$v;
      },
      expression: "revokeDeliveryStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_revoke_return_status",
      "value": "revoke_return_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "revoke_return_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "revoke_return_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("退貨狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.revokeReturnStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('revoke_return_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'revokeReturnStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('revoke_return_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeReturnStatusIncludeJson,
      callback: function callback($$v) {
        _vm.revokeReturnStatusIncludeJson = $$v;
      },
      expression: "revokeReturnStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeReturnStatusExcludeJson,
      callback: function callback($$v) {
        _vm.revokeReturnStatusExcludeJson = $$v;
      },
      expression: "revokeReturnStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-3 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_revoke_payment_status",
      "value": "revoke_payment_status_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "revoke_payment_status_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "revoke_payment_status_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("付款狀態，後")]), _c('div', {
    staticClass: "m-1"
  }, [_c('b-form-input', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "type": "number",
      "value": _vm.revokePaymentStatusCondition.days,
      "disabled": !_vm.conditionsCheckboxType.includes('revoke_payment_status_filter'),
      "min": "0",
      "step": "1",
      "size": "sm"
    },
    on: {
      "keydown": function keydown($event) {
        return _vm.preventInvalidNumberKey($event, 0);
      },
      "input": function input($event) {
        return _vm.onPositiveIntInput($event, 'revokePaymentStatusCondition.days', 0);
      }
    }
  })], 1), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("天")])]), _vm.conditionsCheckboxType.includes('revoke_payment_status_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許狀態 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokePaymentStatusIncludeJson,
      callback: function callback($$v) {
        _vm.revokePaymentStatusIncludeJson = $$v;
      },
      expression: "revokePaymentStatusIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除當下狀態 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokePaymentStatusExcludeJson,
      callback: function callback($$v) {
        _vm.revokePaymentStatusExcludeJson = $$v;
      },
      expression: "revokePaymentStatusExcludeJson"
    }
  })], 1)]) : _vm._e()]), _c('b-form-group', {
    staticClass: "mb-0 ml-4"
  }, [_c('div', {
    staticClass: "d-flex align-items-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: _vm.conditionsCheckboxType,
      expression: "conditionsCheckboxType"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox",
      "id": "conditionsCheckboxType_revoke_branch_list",
      "value": "revoke_branch_list_filter"
    },
    domProps: {
      "checked": Array.isArray(_vm.conditionsCheckboxType) ? _vm._i(_vm.conditionsCheckboxType, "revoke_branch_list_filter") > -1 : _vm.conditionsCheckboxType
    },
    on: {
      "change": function change($event) {
        var $$a = _vm.conditionsCheckboxType,
          $$el = $event.target,
          $$c = $$el.checked ? true : false;
        if (Array.isArray($$a)) {
          var $$v = "revoke_branch_list_filter",
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.conditionsCheckboxType = $$a.concat([$$v]));
          } else {
            $$i > -1 && (_vm.conditionsCheckboxType = $$a.slice(0, $$i).concat($$a.slice($$i + 1)));
          }
        } else {
          _vm.conditionsCheckboxType = $$c;
        }
      }
    }
  }), _c('div', {
    staticClass: "m-1"
  }, [_vm._v("允許/排除 分店名單")])]), _vm.conditionsCheckboxType.includes('revoke_branch_list_filter') ? _c('div', {
    staticClass: "mt-2 ml-4"
  }, [_c('div', {
    staticClass: "mb-3"
  }, [_c('div', {
    staticClass: "small text-primary mb-1"
  }, [_vm._v("允許分店 (白名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeBranchListIncludeJson,
      callback: function callback($$v) {
        _vm.revokeBranchListIncludeJson = $$v;
      },
      expression: "revokeBranchListIncludeJson"
    }
  })], 1), _c('div', [_c('div', {
    staticClass: "small text-danger mb-1"
  }, [_vm._v("排除分店 (黑名單)")]), _c('editor', {
    staticClass: "border rounded shadow-sm",
    attrs: {
      "width": "100%",
      "height": "100px",
      "lang": "json",
      "theme": "chrome"
    },
    on: {
      "init": _vm.editorInit
    },
    model: {
      value: _vm.revokeBranchListExcludeJson,
      callback: function callback($$v) {
        _vm.revokeBranchListExcludeJson = $$v;
      },
      expression: "revokeBranchListExcludeJson"
    }
  })], 1)]) : _vm._e()])], 1)])]), _c('div', {
    staticClass: "card mb-3"
  }, [_c('div', {
    staticClass: "card-header d-flex justify-content-between align-items-center py-2"
  }, [_c('span', {
    staticClass: "font-weight-bold"
  }, [_vm._v("點數處理")])]), _c('div', {
    staticClass: "card-body"
  }, [_c('b-form-group', {
    attrs: {
      "label-cols": "auto",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-flex align-items-center mr-3"
        }, [_vm._v(" 退貨後回收點數 "), _c('i', {
          staticClass: "fa fa-question-circle ml-2",
          attrs: {
            "id": "refund-point-tooltip"
          }
        })])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.module.module_config.allow_revoke_reward_points,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config, "allow_revoke_reward_points", $$v);
      },
      expression: "module.module_config.allow_revoke_reward_points"
    }
  })], 1), _c('b-tooltip', {
    attrs: {
      "target": "refund-point-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 退貨時自動收回已發放點數 ")])], 1), _c('b-form-group', {
    staticClass: "mb-0",
    attrs: {
      "label-cols": "auto",
      "label-size": "sm"
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_c('span', {
          staticClass: "d-inline-flex align-items-center mr-3"
        }, [_vm._v(" 整張訂單退貨後，返還點數 "), _c('i', {
          staticClass: "fa fa-question-circle ml-2",
          attrs: {
            "id": "return-reward-points-used-tooltip"
          }
        })])];
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "d-flex align-items-center h-100"
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.module.module_config.allow_return_reward_points_used,
      callback: function callback($$v) {
        _vm.$set(_vm.module.module_config, "allow_return_reward_points_used", $$v);
      },
      expression: "module.module_config.allow_return_reward_points_used"
    }
  })], 1), _c('b-tooltip', {
    attrs: {
      "target": "return-reward-points-used-tooltip",
      "triggers": "hover",
      "placement": "right"
    }
  }, [_vm._v(" 整張訂單退貨後，返還給會員於該訂單所使用之點數 ")])], 1)], 1)])])])], 1)], 1), _c('div', {
    staticClass: "mt-4 d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-4",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.goToList
    }
  }, [_vm._v(" 返回 ")]), _c('b-overlay', {
    staticClass: "d-inline-block",
    attrs: {
      "rounded": "",
      "opacity": "0.6",
      "spinner-small": "",
      "spinner-variant": "primary"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "success",
      "disabled": !_vm.isFormEnabled
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 送出 ")])], 1)], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }